/* Elite Fanstore - Page panier, style refonte (assets/panier-refonte.js).
   Chargé par sections/main-cart-items.liquid quand « Style refonte » est coché.
   Traduit les textes qu'APO (Advanced Product Options) affiche en anglais au panier : lien « Edit Options » et fenêtre
   de modification (Cancel, Submit, Qty, Characters left, -- Please Select --, avertissements), et remet ses prix
   « (+€2.50 EUR) » au format de la langue. Les textes d'APO se règlent dans l'app en une seule langue : on ne remplace
   que les textes anglais d'origine, jamais un texte personnalisé.
   Règle d'or d'APO : on ne déplace ni ne remplace aucun champ, on ne touche qu'aux nœuds de texte et à quelques attributs. */
(function () {
  'use strict';
  if (window.__pnApoI18n) return;
  window.__pnApoI18n = true;

  var lang = String((window.Shopify && Shopify.locale) || document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  var I18N = {
    fr: {
      perso: 'Mon patch', edit: 'Éditer les options', modifier: 'Modifier', personnaliser: 'Personnaliser', sur: 'Personnalisation', cancel: 'Annuler', submit: 'Enregistrer', close: 'Fermer',
      qty: 'Quantité', left: 'Caractères restants :', select: '— Choisir —',
      tip: 'Le prix au panier peut varier légèrement selon le taux de change.',
      required: function (n) { return '« ' + n + ' » est obligatoire'; },
      length: function (a, b) { return 'Entre ' + a + ' et ' + b + ' caractères'; },
      number: function (a, b) { return 'Nombre entre ' + a + ' et ' + b; },
      limit: function (a, b) { return 'Choix : ' + a + ' minimum, ' + b + ' maximum'; },
      cartError: 'Impossible de mettre à jour le panier. Merci de réessayer.'
    },
    en: {
      perso: 'My patch', edit: 'Edit options', modifier: 'Edit', personnaliser: 'Customise', sur: 'Customisation', cancel: 'Cancel', submit: 'Save', close: 'Close',
      qty: 'Quantity', left: 'Characters left:', select: '— Select —',
      tip: 'The price in the cart may vary slightly with the exchange rate.',
      required: function (n) { return '“' + n + '” is required'; },
      length: function (a, b) { return 'Between ' + a + ' and ' + b + ' characters'; },
      number: function (a, b) { return 'Number between ' + a + ' and ' + b; },
      limit: function (a, b) { return 'Choose at least ' + a + ', at most ' + b; },
      cartError: 'We could not update your cart. Please try again.'
    },
    es: {
      perso: 'Mi parche', edit: 'Editar opciones', modifier: 'Modificar', personnaliser: 'Personalizar', sur: 'Personalización', cancel: 'Cancelar', submit: 'Guardar', close: 'Cerrar',
      qty: 'Cantidad', left: 'Caracteres restantes:', select: '— Elegir —',
      tip: 'El precio en el carrito puede variar ligeramente según el tipo de cambio.',
      required: function (n) { return '«' + n + '» es obligatorio'; },
      length: function (a, b) { return 'Entre ' + a + ' y ' + b + ' caracteres'; },
      number: function (a, b) { return 'Número entre ' + a + ' y ' + b; },
      limit: function (a, b) { return 'Elige entre ' + a + ' y ' + b; },
      cartError: 'No se ha podido actualizar el carrito. Inténtalo de nuevo.'
    },
    de: {
      perso: 'Mein Patch', edit: 'Optionen bearbeiten', modifier: 'Ändern', personnaliser: 'Personalisieren', sur: 'Personalisierung', cancel: 'Abbrechen', submit: 'Speichern', close: 'Schließen',
      qty: 'Menge', left: 'Verbleibende Zeichen:', select: '— Auswählen —',
      tip: 'Der Preis im Warenkorb kann je nach Wechselkurs leicht abweichen.',
      required: function (n) { return '„' + n + '“ ist erforderlich'; },
      length: function (a, b) { return 'Zwischen ' + a + ' und ' + b + ' Zeichen'; },
      number: function (a, b) { return 'Zahl zwischen ' + a + ' und ' + b; },
      limit: function (a, b) { return 'Mindestens ' + a + ', höchstens ' + b + ' auswählen'; },
      cartError: 'Der Warenkorb konnte nicht aktualisiert werden. Bitte erneut versuchen.'
    },
    it: {
      perso: 'La mia patch', edit: 'Modifica opzioni', modifier: 'Modifica', personnaliser: 'Personalizza', sur: 'Personalizzazione', cancel: 'Annulla', submit: 'Salva', close: 'Chiudi',
      qty: 'Quantità', left: 'Caratteri rimanenti:', select: '— Scegli —',
      tip: 'Il prezzo nel carrello può variare leggermente in base al tasso di cambio.',
      required: function (n) { return '«' + n + '» è obbligatorio'; },
      length: function (a, b) { return 'Tra ' + a + ' e ' + b + ' caratteri'; },
      number: function (a, b) { return 'Numero tra ' + a + ' e ' + b; },
      limit: function (a, b) { return 'Scegli da ' + a + ' a ' + b; },
      cartError: 'Impossibile aggiornare il carrello. Riprova.'
    },
    pt: {
      perso: 'O meu patch', edit: 'Editar opções', modifier: 'Alterar', personnaliser: 'Personalizar', sur: 'Personalização', cancel: 'Cancelar', submit: 'Guardar', close: 'Fechar',
      qty: 'Quantidade', left: 'Caracteres restantes:', select: '— Escolher —',
      tip: 'O preço no carrinho pode variar ligeiramente com a taxa de câmbio.',
      required: function (n) { return '«' + n + '» é obrigatório'; },
      length: function (a, b) { return 'Entre ' + a + ' e ' + b + ' caracteres'; },
      number: function (a, b) { return 'Número entre ' + a + ' e ' + b; },
      limit: function (a, b) { return 'Escolha entre ' + a + ' e ' + b; },
      cartError: 'Não foi possível atualizar o carrinho. Tente novamente.'
    },
    sv: {
      perso: 'Min patch', edit: 'Redigera alternativ', modifier: 'Ändra', personnaliser: 'Anpassa', sur: 'Anpassning', cancel: 'Avbryt', submit: 'Spara', close: 'Stäng',
      qty: 'Antal', left: 'Tecken kvar:', select: '— Välj —',
      tip: 'Priset i varukorgen kan variera något beroende på växelkursen.',
      required: function (n) { return '”' + n + '” är obligatoriskt'; },
      length: function (a, b) { return 'Mellan ' + a + ' och ' + b + ' tecken'; },
      number: function (a, b) { return 'Tal mellan ' + a + ' och ' + b; },
      limit: function (a, b) { return 'Välj minst ' + a + ', högst ' + b; },
      cartError: 'Varukorgen kunde inte uppdateras. Försök igen.'
    }
  };
  var T = I18N[lang] || I18N.fr;
  var LOCALE = { fr: 'fr-FR', en: 'en-IE', es: 'es-ES', de: 'de-DE', it: 'it-IT', pt: 'pt-PT', sv: 'sv-SE' }[lang] || 'fr-FR';
  var activeCurrency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';

  // « (+€2.50 EUR) », « +€2.50 », « (+2,50 € EUR) »… → « +2,50 € » (format de la langue). null si ce n'est pas un prix APO.
  var PRICE = /\(?\s*([+\-−])\s*([^\d\s()+\-−]{0,3})\s*(\d[\d.,\s]*\d|\d)\s*([^\d\s()]{0,3})\s*([A-Z]{3})?\s*\)?/;
  function money(txt) {
    var m = PRICE.exec(txt);
    if (!m) return null;
    var raw = m[3].replace(/\s/g, '');
    // APO écrit 2.50 (point décimal) ; on accepte aussi 2,50 et 1.234,50
    var dec = raw.match(/[.,](\d{1,2})$/);
    var n = dec ? parseFloat(raw.slice(0, -dec[0].length).replace(/[.,]/g, '') + '.' + dec[1]) : parseFloat(raw.replace(/[.,]/g, ''));
    if (!isFinite(n)) return null;
    var code = m[5] || activeCurrency;
    var out;
    try { out = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: code }).format(n); } catch (e) { return null; }
    return { match: m[0], text: (m[1] === '+' ? '+' : '−') + out };
  }

  function setText(node, value) { if (node.nodeValue !== value) node.nodeValue = value; }
  function textNodes(el) {
    var out = [], w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    while (w.nextNode()) out.push(w.currentNode);
    return out;
  }
  function swapExact(el, en, value) {
    textNodes(el).forEach(function (t) { if (t.nodeValue.trim() === en) setText(t, t.nodeValue.replace(en, value)); });
  }

  function traduire(root) {
    if (!root || root.nodeType !== 1) return;

    // Lien du panier « Edit Options »
    var links = root.matches && root.matches('.mw-apo-configure-link') ? [root] : root.querySelectorAll('.mw-apo-configure-link');
    Array.prototype.forEach.call(links, function (a) { swapExact(a, 'Edit Options', T.edit); });

    var modals = root.matches && root.matches('.mw-tingle') ? [root] : root.querySelectorAll('.mw-tingle');
    if (!modals.length && root.closest) { var up = root.closest('.mw-tingle'); if (up) modals = [up]; }
    Array.prototype.forEach.call(modals, traduireFenetre);
  }

  function traduireFenetre(m) {
    if (!m.querySelector('.mw-product-info')) return; // pas la fenêtre de modification
    m.classList.add('pn-apo');
    m.setAttribute('lang', lang);

    // Surtitre rouge au-dessus du nom du produit (seul ajout : un <p> hors des champs d'APO)
    var title = m.querySelector('.mw-product-info__title');
    if (title && !m.querySelector('.pn-apo__sur')) {
      var sur = document.createElement('p');
      sur.className = 'pn-apo__sur';
      sur.textContent = T.sur;
      title.parentNode.insertBefore(sur, title);
    }

    // Boutons et fermeture
    Array.prototype.forEach.call(m.querySelectorAll('.tingle-modal-box__footer button'), function (b) {
      swapExact(b, 'Cancel', T.cancel);
      swapExact(b, 'Submit', T.submit);
      if (b.classList.contains('btn--primary')) b.classList.add('pn-apo__submit');
      if (b.classList.contains('btn--secondary')) b.classList.add('pn-apo__cancel');
    });
    var close = m.querySelector('.tingle-modal__close');
    if (close) {
      close.setAttribute('aria-label', T.close);
      var cl = close.querySelector('.tingle-modal__closeLabel');
      if (cl) swapExact(cl, 'Close', T.close);
    }

    // Quantité
    var q = m.querySelector('.mw-product-info__quantity');
    if (q) {
      q.classList.add('pn-apo__qty');
      textNodes(q).forEach(function (t) { if (/^\s*Qty:?\s*$/.test(t.nodeValue)) setText(t, T.qty); });
    }

    // « Characters left: » (le compteur <span> qui suit reste celui d'APO)
    Array.prototype.forEach.call(m.querySelectorAll('.mw-option__helptext'), function (h) {
      textNodes(h).forEach(function (t) {
        var v = t.nodeValue, r;
        if (/^\s*Characters left:?\s*$/.test(v)) setText(t, T.left + ' ');
        else if ((r = /Length range, min=(\d+); max=(\d+)/.exec(v))) setText(t, T.length(r[1], r[2]));
        else if ((r = /Number range, min=([\d.,-]+); max=([\d.,-]+)/.exec(v))) setText(t, T.number(r[1], r[2]));
        else if ((r = /Selection limit, min=(\d+); max=(\d+)/.exec(v))) setText(t, T.limit(r[1], r[2]));
        else if ((r = /^\s*"(.+)" is required\s*$/.exec(v))) setText(t, T.required(r[1]));
      });
    });

    // Prix des options : « (+€2.50 EUR) » → « +2,50 € » ; infobulle traduite
    Array.prototype.forEach.call(m.querySelectorAll('.mw-option__price'), function (p) {
      textNodes(p).forEach(function (t) {
        if (/[A-Z]{3}\)|\(\+/.test(t.nodeValue)) { var f = money(t.nodeValue); if (f) setText(t, t.nodeValue.replace(f.match, f.text).trim()); }
      });
      if (/conversion rate/.test(p.getAttribute('data-mw-tooltip') || '')) p.setAttribute('data-mw-tooltip', T.tip);
    });

    // Listes : « -- Please Select -- » et prix dans les choix
    Array.prototype.forEach.call(m.querySelectorAll('select option'), function (o) {
      var v = o.textContent;
      if (/^\s*-- Please Select --\s*$/.test(v)) { o.textContent = T.select; return; }
      if (/\(\+[^)]*[A-Z]{3}\)/.test(v)) {
        var f = money(v.slice(v.indexOf('(')));
        if (f) o.textContent = v.replace(/\(\+[^)]*\)/, '(' + f.text + ')').trim();
      }
    });

    // Erreur de mise à jour du panier
    Array.prototype.forEach.call(m.querySelectorAll('.mw-apo-cart-error'), function (e) {
      if (/could not add this to your cart/i.test(e.textContent)) e.textContent = T.cartError;
    });

    patchsEnPhotos(m);
  }

  /* ── Patchs en photos dans la fenêtre ───────────────────────────────
     Mêmes photos, mêmes règles par équipe, même limite et même supplément que le volet de la fiche produit :
     window.pnPatchs est généré depuis snippets/elite-flocage.liquid par Connection/deploy-panier-refonte.mjs
     (snippets/panier-patchs.liquid). Le champ texte « Patchs » d'APO reste en place, masqué : un clic sur une photo
     y écrit la liste (séparée par « | ») comme une saisie ; la liste « Patchs supplémentaires », masquée elle aussi,
     est réglée sur le nombre de patchs moins un. */
  var MAX_TXT = { fr: '[n] max', en: 'max [n]', es: 'máx. [n]', de: 'max. [n]', it: 'max [n]', pt: 'máx. [n]', sv: 'max [n]' }[lang] || '[n] max';
  var SEP = ' | ';
  var produitCourant = null; // produit de la ligne dont on a cliqué « Éditer les options »
  var persoEdition = null;   // photos « Patch perso » de cette ligne : { cartId, productId, urls: { n: lien }, t }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.mw-apo-configure-link');
    if (!a) return;
    produitCourant = a.getAttribute('data-mw-apo-configure-link');
    persoEdition = lirePerso(a);
    if (persoEdition) gardePerso(persoEdition);
  }, true);

  function fire(input) {
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function choisis(val) {
    return val ? val.split('|').map(function (v) { return v.trim(); }).filter(Boolean) : [];
  }
  function nombreEnTete(texte) {
    var r = String(texte || '').match(/^\s*(\d+)/);
    return r ? parseInt(r[1], 10) : 0;
  }
  function libelle(o) {
    var t = o.querySelector('.mw-text--style-strong');
    return t ? t.textContent : '';
  }
  function optionPatchs(m) {
    var opts = m.querySelectorAll('.mw-option');
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].querySelector('input.mw-option__control[type="text"]') && (opts[i].getAttribute('data-option-id') === 'o_3340742' || /patch|parche/i.test(libelle(opts[i])))) return opts[i];
    }
    return null;
  }
  function optionSupplement(m) {
    var ids = (window.pnPatchs && pnPatchs.extraIds) || [];
    var opts = m.querySelectorAll('.mw-option');
    var parValeurs = null;
    for (var i = 0; i < opts.length; i++) {
      var sel = opts[i].querySelector('select');
      if (!sel) continue;
      if (ids.indexOf(opts[i].getAttribute('data-option-id')) > -1 || /patch|parche/i.test(libelle(opts[i]))) return opts[i];
      var vals = Array.prototype.filter.call(sel.options, function (o) { return o.value !== ''; });
      if (!parValeurs && vals.length && vals.every(function (o) { return nombreEnTete(o.text) > 0; })) parValeurs = opts[i];
    }
    return parValeurs;
  }
  // Règle la liste sur n patchs supplémentaires (plus grand cran disponible), 0 = valeur vide d'APO, jamais « 1 ».
  function ajusteSupplement(m, n) {
    var o = optionSupplement(m);
    if (!o) return;
    var sel = o.querySelector('select');
    var index = -1, vide = -1, applique = 0;
    for (var i = 0; i < sel.options.length; i++) {
      var k = nombreEnTete(sel.options[i].text);
      if (!k && vide < 0) vide = i;
      if (k && k <= n && k > applique) { applique = k; index = i; }
    }
    if (index < 0) index = vide;
    if (sel.selectedIndex !== index) { sel.selectedIndex = index; fire(sel); }
  }

  function patchsEnPhotos(m) {
    var data = window.pnPatchs;
    if (!data || typeof data.pour !== 'function') return;
    var opt = optionPatchs(m);
    if (!opt) return;
    var input = opt.querySelector('input.mw-option__control[type="text"]');
    var grid = opt.querySelector('.pn-pg');
    if (!grid) {
      var info = data.produits && data.produits[produitCourant];
      if (!info && data.produits) {
        // repli : le titre de la fenêtre est « Nom du produit - Taille »
        var titre = (m.querySelector('.mw-product-info__title') || {}).textContent || '';
        Object.keys(data.produits).forEach(function (k) {
          var t = data.produits[k].titre;
          if (!info && t && titre.trim().indexOf(t) === 0) info = data.produits[k];
        });
      }
      if (!info) return;
      var liste;
      // id et handle : patchs des maillots rétro (associations par produit, comme sur la fiche)
      try { liste = data.pour(info.tags || [], info.texte || '', false, info.id, info.handle) || []; } catch (e) { return; }
      // photos envoyées par le client (« Mon patch ») encore sur la ligne, dans l'ordre de la liste
      var urls = (persoEdition && persoEdition.urls) || {};
      var persos = choisis(input.value).filter(function (v) { return urls[numeroPerso(v)]; });
      if (!liste.length && !persos.length) return; // équipe non reconnue, sans photo : le champ texte d'APO reste tel quel
      var max = data.max || 4;

      grid = document.createElement('div');
      grid.className = 'pn-pg';
      liste.forEach(function (p) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pn-pg__tile';
        b.setAttribute('aria-pressed', 'false');
        b.setAttribute('data-v', p.valeur);
        b.innerHTML =
          '<span class="pn-pg__pic"><img alt="" width="520" height="520" loading="lazy" decoding="async"></span>' +
          '<span class="pn-pg__name"><span></span></span>' +
          '<svg class="pn-pg__check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"></path></svg>';
        b.querySelector('img').src = p.img;
        b.querySelector('.pn-pg__name > span').textContent = p.nom;
        grid.appendChild(b);
      });
      // une case par photo du client, déjà cochée, pour pouvoir la garder ou la retirer
      persos.forEach(function (v, i) {
        var bp = document.createElement('button');
        bp.type = 'button';
        bp.className = 'pn-pg__tile pn-pg__tile--perso';
        bp.setAttribute('aria-pressed', 'false');
        bp.setAttribute('data-v', v);
        bp.innerHTML =
          '<span class="pn-pg__pic"><img alt="" width="520" height="520" decoding="async"></span>' +
          '<span class="pn-pg__name"><span></span></span>' +
          '<svg class="pn-pg__check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"></path></svg>';
        bp.querySelector('img').src = urls[numeroPerso(v)];
        bp.querySelector('.pn-pg__name > span').textContent = nomPerso(i + 1, persos.length);
        grid.appendChild(bp);
      });
      grid.setAttribute('data-max', max);

      var compteur = null;
      if (liste.length + persos.length > max) {
        compteur = document.createElement('span');
        compteur.className = 'mw-stack__item pn-pg__count';
        compteur.setAttribute('aria-live', 'polite');
        var rangee = opt.querySelector('label.mw-label .mw-stack');
        if (rangee) rangee.appendChild(compteur);
      }

      grid.addEventListener('click', function (e) {
        var tile = e.target.closest('.pn-pg__tile');
        if (!tile) return;
        var v = tile.getAttribute('data-v');
        var avant = choisis(input.value);
        var dejaLa = avant.indexOf(v) > -1;
        if (!dejaLa && avant.length >= max) {
          if (compteur) { compteur.classList.remove('is-bump'); void compteur.offsetWidth; compteur.classList.add('is-bump'); }
          return;
        }
        var apres = dejaLa ? avant.filter(function (x) { return x !== v; }) : avant.concat(v);
        var ordre = Array.prototype.map.call(grid.querySelectorAll('.pn-pg__tile'), function (t) { return t.getAttribute('data-v'); });
        // une valeur sans photo dans cette fenêtre (« Mon patch », saisie ancienne) est gardée au bout
        input.value = ordre.filter(function (x) { return apres.indexOf(x) > -1; })
          .concat(apres.filter(function (x) { return ordre.indexOf(x) < 0; })).join(SEP);
        fire(input);
        ajusteSupplement(m, Math.max(0, choisis(input.value).length - 1));
        sync();
      });

      function sync() {
        var sel = choisis(input.value);
        var plein = sel.length >= max;
        Array.prototype.forEach.call(grid.querySelectorAll('.pn-pg__tile'), function (t) {
          var on = sel.indexOf(t.getAttribute('data-v')) > -1;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-pressed', String(on));
          t.classList.toggle('is-locked', plein && !on);
          t.setAttribute('aria-disabled', String(plein && !on));
        });
        if (compteur) {
          compteur.textContent = sel.length ? sel.length + '/' + max : MAX_TXT.replace('[n]', max);
          compteur.classList.toggle('is-full', plein);
        }
      }

      opt.classList.add('pn-patchs');
      input.tabIndex = -1;
      var cont = input.closest('.mw-option__container');
      if (cont) cont.setAttribute('aria-hidden', 'true');
      opt.addEventListener('click', function (e) { if (e.target.closest('label')) e.preventDefault(); });
      input.addEventListener('input', sync);
      opt.appendChild(grid);
      sync();

      var extra = optionSupplement(m);
      if (extra) {
        extra.classList.add('pn-patchs-extra');
        extra.setAttribute('aria-hidden', 'true');
        var s = extra.querySelector('select');
        if (s) s.tabIndex = -1;
      }
    }
  }

  /* ── Patchs en photos sur les lignes du panier ────────────────────
     Le thème affiche la propriété « Patchs » en texte brut (« Champion Ligue 1 2025-2026 - PSG | UEFA… ») et la photo
     envoyée par le client (« Patch perso ») comme un simple lien. On ajoute sous les options les vignettes des patchs
     choisis, avec les photos de la fiche (catalogue de window.pnPatchs) ; le texte d'origine reste dans la page, masqué.
     La ligne technique « Patchs supplémentaires » (nombre de patchs facturés en plus du premier) est masquée aussi. */
  var PERSO_VALEUR = 'Patch personnalisé (photo jointe)';
  // Plusieurs photos depuis le 13/10/2026 : la photo n a la valeur « Patch personnalisé n (photo jointe) » et la
  // propriété « Patch perso n » ; la 1re garde les noms sans numéro (snippets/elite-flocage.liquid).
  function valeurPerso(n) { return n > 1 ? 'Patch personnalisé ' + n + ' (photo jointe)' : PERSO_VALEUR; }
  function numeroPerso(v) {
    var r = /^Patch personnalisé(?: (\d+))? \(photo jointe\)$/.exec(String(v || '').trim());
    return r ? (r[1] ? parseInt(r[1], 10) : 1) : 0;
  }
  function numeroPropriete(k) {
    var r = /^patch perso(?: (\d+))?$/i.exec(String(k || '').trim());
    return r ? (r[1] ? parseInt(r[1], 10) : 1) : 0;
  }
  function proprietePerso(n) { return 'Patch perso' + (n > 1 ? ' ' + n : ''); }
  // « Mon patch », ou « Mon patch 1 », « Mon patch 2 »… quand il y en a plusieurs, comme sur la fiche
  function nomPerso(rang, total) { return T.perso + (total > 1 ? ' ' + rang : ''); }
  var catalogue = null;
  function patchDuCatalogue(v) {
    if (!catalogue || !catalogue.length) {
      try { catalogue = (window.pnPatchs && typeof pnPatchs.catalogue === 'function' && pnPatchs.catalogue()) || []; } catch (e) { catalogue = []; }
    }
    for (var i = 0; i < catalogue.length; i++) if (catalogue[i].valeur === v) return catalogue[i];
    return null;
  }
  function cleOption(o) {
    var dt = o.querySelector('dt');
    return dt ? dt.textContent.replace(/:\s*$/, '').trim() : '';
  }
  function vignette(src, nom, lien) {
    var el = document.createElement(lien ? 'a' : 'span');
    el.className = 'pn-lp__item' + (src ? '' : ' pn-lp__item--texte');
    if (lien) { el.href = lien; el.target = '_blank'; el.rel = 'noopener'; }
    if (src) {
      // image de fond, pas de <img> : pour poser « Éditer les options », APO cherche le lien du nom du produit et
      // écarte tout lien dont le bloc parent contient une <img> (il le prend pour la photo) — vérifié le 11/10/2026
      var pic = document.createElement('span');
      pic.className = 'pn-lp__pic';
      pic.setAttribute('aria-hidden', 'true');
      pic.style.backgroundImage = 'url("' + String(src).replace(/["\\\n]/g, '') + '")';
      el.appendChild(pic);
    }
    var n = document.createElement('span');
    n.className = 'pn-lp__nom';
    n.textContent = nom;
    el.appendChild(n);
    return el;
  }
  function lignesPanier() {
    // lignes de la page seulement : le tiroir panier (elite-tiroir.js, 21/10/2026) a ses propres étiquettes
    Array.prototype.forEach.call(document.querySelectorAll('.cart-item:not(.cart-drawer-item)'), function (item) {
      if (item.querySelector('.pn-lp')) return; // déjà fait : le thème refait la ligne entière quand elle change
      var optPatchs = null, optsPerso = [], urls = {};
      Array.prototype.forEach.call(item.querySelectorAll('.product-option'), function (o) {
        var k = cleOption(o);
        if (!k) return;
        var n = numeroPropriete(k);
        if (n) {
          optsPerso.push(o);
          var a = o.querySelector('a[href]');
          if (a) urls[n] = a.getAttribute('href');
        } else if (/patch|parche/i.test(k) && /suppl|extra|adicional|zus[aä]tz|aggiunt|ytterlig|adiciona/i.test(k)) {
          o.classList.add('pn-opt-cache');
        } else if (/patch|parche/i.test(k)) {
          optPatchs = o;
        }
      });
      var repere = optPatchs || optsPerso[0];
      if (!repere) return;
      // photos connues pour ce produit (vues plus tôt dans la session) : affichées même si APO vient d'effacer les propriétés
      var lienProduit = item.querySelector('a.cart-item__name[href], a[href*="/products/"]');
      var handle = lienProduit ? (lienProduit.getAttribute('href').split('/products/')[1] || '').split(/[?#]/)[0] : '';
      var photoSurLaLigne = Object.keys(urls).length > 0;
      if (photoSurLaLigne && handle) photosConnues(handle, urls);
      if (!photoSurLaLigne && handle) urls = photosConnues(handle) || {};
      var valeurs = optPatchs ? choisis((optPatchs.querySelector('dd') || {}).textContent || '') : [];
      if (photoSurLaLigne) Object.keys(urls).forEach(function (n) {
        if (valeurs.indexOf(valeurPerso(+n)) < 0) valeurs.push(valeurPerso(+n));
      });
      if (!valeurs.length) return;
      var persos = valeurs.filter(numeroPerso);

      var box = document.createElement('div');
      box.className = 'pn-lp';
      var titre = document.createElement('p');
      titre.className = 'pn-lp__titre';
      titre.textContent = optPatchs ? cleOption(optPatchs) : 'Patch';
      box.appendChild(titre);
      var grille = document.createElement('div');
      grille.className = 'pn-lp__grille';
      valeurs.forEach(function (v) {
        var n = numeroPerso(v);
        if (n) {
          // photo du client : vignette cliquable vers l'image envoyée (ou simple étiquette si elle manque)
          grille.appendChild(vignette(urls[n] || null, nomPerso(persos.indexOf(v) + 1, persos.length), urls[n] || null));
          return;
        }
        var p = patchDuCatalogue(v);
        grille.appendChild(p ? vignette(p.img, p.nom) : vignette(null, v));
      });
      box.appendChild(grille);
      repere.parentNode.insertBefore(box, repere.nextSibling);
      if (optPatchs) optPatchs.classList.add('pn-opt-cache');
      optsPerso.forEach(function (o) { o.classList.add('pn-opt-cache'); });
    });
  }

  /* ── Photos « Patch perso » après « Éditer les options » ────────────
     APO réécrit la ligne avec ses seules options quand on enregistre la fenêtre : les propriétés « Patch perso »,
     « Patch perso 2 »… (liens des photos envoyées depuis la fiche) disparaissent alors que « Patch personnalisé (photo
     jointe) » reste facturé dans « Patchs » (constaté en panier réel le 11/10/2026). On note les photos à l'ouverture
     de la fenêtre (sessionStorage : APO peut recharger la page), puis on surveille le panier : si la ligne a encore un
     patch photo mais plus son lien, on lui remet la propriété par /cart/change.js en recopiant toutes les autres, y
     compris celles d'APO qui portent le prix. Une photo décochée dans la fenêtre n'est pas remise. */
  var CLE_PERSO = 'pnPersoEdition';
  function proprietePatchs(props) {
    for (var k in props) if (/patch|parche/i.test(k) && !numeroPropriete(k) && !/suppl|extra|adicional|zus[aä]tz|aggiunt|ytterlig|adiciona/i.test(k)) return props[k];
    return '';
  }
  function lirePerso(a) {
    var item = a.closest('.cart-item');
    if (!item) return null;
    var urls = {}, trouve = false;
    Array.prototype.forEach.call(item.querySelectorAll('.product-option'), function (o) {
      var n = numeroPropriete(cleOption(o));
      var l = n && o.querySelector('a[href]');
      if (l) { urls[n] = l.getAttribute('href'); trouve = true; }
    });
    return trouve ? { cartId: a.getAttribute('data-mw-apo-cart-id') || '', productId: a.getAttribute('data-mw-apo-configure-link') || '', urls: urls, t: Date.now() } : null;
  }
  function gardePerso(p) {
    try { sessionStorage.setItem(CLE_PERSO, JSON.stringify(p)); } catch (e) {}
    surveillePerso();
  }
  function persoEnAttente() {
    try {
      var p = JSON.parse(sessionStorage.getItem(CLE_PERSO) || 'null');
      if (p && !p.urls && p.url) p.urls = { 1: p.url }; // noté avant le 13/10/2026 : une seule photo
      if (p && Date.now() - p.t < 30 * 60 * 1000) return p;
      sessionStorage.removeItem(CLE_PERSO);
    } catch (e) {}
    return null;
  }
  function oubliePerso() { try { sessionStorage.removeItem(CLE_PERSO); } catch (e) {} }
  // handle du produit → liens des photos { n: lien } ; lecture si urls est absent
  function photosConnues(handle, urls) {
    var m = {};
    try { m = JSON.parse(sessionStorage.getItem('pnPersoPhotos') || '{}') || {}; } catch (e) {}
    if (!urls) return typeof m[handle] === 'string' ? { 1: m[handle] } : (m[handle] || null);
    m[handle] = urls;
    try { sessionStorage.setItem('pnPersoPhotos', JSON.stringify(m)); } catch (e) {}
    return urls;
  }

  var restaureEnCours = false;
  function restaurePerso() {
    var p = persoEnAttente();
    if (!p || restaureEnCours) return;
    restaureEnCours = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cible = null, manquent = [];
        (cart.items || []).forEach(function (it) {
          var pr = it.properties || {};
          if (String(it.product_id) !== String(p.productId)) return;
          // photos encore facturées dans « Patchs » dont le lien a disparu
          var vals = choisis(proprietePatchs(pr));
          var aRemettre = Object.keys(p.urls || {}).filter(function (n) {
            return vals.indexOf(valeurPerso(+n)) > -1 && !pr[proprietePerso(+n)];
          });
          if (!aRemettre.length) return;
          // la même ligne de préférence (identifiant APO), sinon la première de ce produit
          if (!cible || String(pr._mws_cart || '') === String(p.cartId)) { cible = it; manquent = aRemettre; }
        });
        // rien à remettre : les liens sont peut-être là mais absents de la donnée d'APO (fenêtre enregistrée)
        if (!cible) return photosDansCommande(cart);
        var props = {};
        for (var k in cible.properties) props[k] = cible.properties[k];
        manquent.forEach(function (n) { props[proprietePerso(+n)] = p.urls[n]; });
        var cta = ctaAvecPhotos(props);
        if (cta) props.__mws_apo_cta = cta;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: cible.key, quantity: cible.quantity, properties: props })
        }).then(function (r) {
          if (!r.ok) return;
          oubliePerso();
          location.reload();
        });
      })
      .catch(function () {})
      .then(function () { restaureEnCours = false; });
  }
  /* ── Photos « Patch perso » jusqu'à la commande ─────────────────────
     Au paiement, le cart transform d'APO remplace la ligne par une ligne « composant » (« Fait partie de … » dans la
     commande) qui ne reprend que les attributs listés dans la propriété cachée __mws_apo_cta
     ({"price":"3.00__","attributes":[{"key":"Patchs",…}]}). Le lien de la photo restait sur la ligne parente, que ni
     l'admin ni le fournisseur n'affichent (signalé le 13/10/2026 : « Patchs : Patch personnalisé (photo jointe) » sans
     photo dans la commande). On recopie chaque « Patch perso n » dans ces attributs, triés par numéro, sans toucher au
     prix : vérifié au paiement le 13/10/2026 (lien « Patch perso » sur la ligne, prix inchangé). Changer les propriétés
     d'une ligne garde sa place (index, utilisé par les boutons de quantité) : la page n'a pas à être rechargée. */
  function ctaAvecPhotos(props) {
    var cta;
    try { cta = JSON.parse(props.__mws_apo_cta || 'null'); } catch (e) { return null; }
    if (!cta || !Array.isArray(cta.attributes)) return null;
    var avant = JSON.stringify(cta.attributes);
    var photos = Object.keys(props).filter(function (k) { return numeroPropriete(k) && props[k]; })
      .sort(function (a, b) { return numeroPropriete(a) - numeroPropriete(b); });
    cta.attributes = cta.attributes.filter(function (a) { return !numeroPropriete(a && a.key); })
      .concat(photos.map(function (k) { return { key: k, value: props[k] }; }));
    return JSON.stringify(cta.attributes) === avant ? null : JSON.stringify(cta);
  }
  var synchroPhotos = null;
  // cart : panier déjà lu (évite un 2e appel à /cart.js)
  function photosDansCommande(cart) {
    if (synchroPhotos) return synchroPhotos;
    synchroPhotos = (cart ? Promise.resolve(cart) : fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }))
      .then(function (c) {
        return (c.items || []).reduce(function (suite, it) {
          var cta = ctaAvecPhotos(it.properties || {});
          if (!cta) return suite;
          return suite.then(function () {
            var props = {};
            for (var k in it.properties) props[k] = it.properties[k];
            props.__mws_apo_cta = cta;
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: it.key, quantity: it.quantity, properties: props })
            });
          });
        }, Promise.resolve());
      })
      .catch(function () {})
      .then(function () { synchroPhotos = null; });
    return synchroPhotos;
  }
  // « Passer la commande » cliqué pendant la recopie : on attend qu'elle finisse
  document.addEventListener('click', function (e) {
    var b = synchroPhotos && e.target.closest && e.target.closest('[name="checkout"], a[href^="/checkout"]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    synchroPhotos.then(function () { b.click(); });
  }, true);

  // Le panier n'est relu que fenêtre fermée, pendant 10 s après sa fermeture (20 s si on ne l'a pas vue s'ouvrir, cas
  // du rechargement par APO) : relire /cart.js toutes les 1,5 s pendant 5 min fait répondre Shopify en 429 (trop de
  // requêtes) sur /cart/*, constaté le 13/10/2026. Au-delà, le contrôle se refait au prochain chargement du panier.
  var veillePerso = null;
  function surveillePerso() {
    if (veillePerso || !persoEnAttente()) return;
    var debut = Date.now(), fermeeA = 0, vue = false;
    function arrete() { clearInterval(veillePerso); veillePerso = null; }
    veillePerso = setInterval(function () {
      var p = persoEnAttente();
      if (!p || Date.now() - p.t > 5 * 60 * 1000) { arrete(); return; }
      if (document.querySelector('.mw-tingle .tingle-modal--visible, .mw-tingle.tingle-modal--visible')) { vue = true; fermeeA = 0; return; }
      if (vue && !fermeeA) fermeeA = Date.now();
      if (vue ? Date.now() - fermeeA > 10000 : Date.now() - debut > 20000) { arrete(); return; }
      restaurePerso();
    }, 1500);
  }

  var pending = new Set();
  var scheduled = false;
  var lignesAFaire = true;
  function flush() {
    scheduled = false;
    pending.forEach(function (n) { if (n.isConnected) traduire(n); });
    pending.clear();
    if (lignesAFaire) { lignesAFaire = false; lignesPanier(); boutonsLignes(); }
  }
  var obs = new MutationObserver(function (records) {
    records.forEach(function (r) {
      var t = r.type === 'characterData' ? r.target.parentElement : r.target;
      if (!t) return;
      var hit = t.closest('.mw-tingle, .mw-apo-configure-link');
      if (hit) pending.add(hit);
      if (r.type === 'childList') Array.prototype.forEach.call(r.addedNodes, function (n) {
        if (n.nodeType === 1 && (n.matches('.mw-tingle, .mw-apo-configure-link') || n.querySelector('.mw-tingle, .mw-apo-configure-link'))) pending.add(n);
        // ligne du panier redessinée par le thème : ses patchs repassent en photos
        if (n.nodeType === 1 && (n.matches('.cart-item, .product-option') || n.querySelector('.cart-item'))) lignesAFaire = true;
      });
    });
    // traité avant l'affichage : pas d'éclair de texte anglais
    if ((pending.size || lignesAFaire) && !scheduled) { scheduled = true; Promise.resolve().then(flush); }
  });

  /* ── « Éditer les options » demandé depuis le tiroir panier (lien « Modifier », 21/10/2026) ──
     /cart?modifier=<identifiant APO de la ligne> : on attend le lien qu'APO pose sur cette ligne et on l'ouvre. La
     fenêtre s'ouvre ici, sur la page panier, où elle est traduite, a les patchs en photos et la remise des photos
     « Patch perso » après enregistrement. Le tiroir appelle aussi pnOuvrirEdition quand on est déjà sur /cart. */
  function ouvrirEdition(id) {
    if (!/^\d+$/.test(String(id || ''))) return;
    var debut = Date.now();
    (function essai() {
      var a = document.querySelector('.cart-item:not(.cart-drawer-item) .mw-apo-configure-link[data-mw-apo-cart-id="' + id + '"]:not([data-mw-apo-buy-again-link])');
      if (a) { a.scrollIntoView({ block: 'center' }); a.click(); return; }
      if (Date.now() - debut < 20000) setTimeout(essai, 300);
    })();
  }
  window.pnOuvrirEdition = ouvrirEdition;

  /* ── Personnaliser une ligne SANS flocage (ajoutée depuis les suggestions du tiroir, 21/10/2026) ──
     Ces lignes n'ont pas d'identifiant APO (_mws_cart) : la fenêtre d'APO s'ouvre quand même sur les options du
     produit, mais « Enregistrer » AJOUTE une nouvelle ligne floquée puis recharge la page (constaté le 21/10/2026).
     On note donc la ligne d'origine avant d'ouvrir la fenêtre ; au rechargement, dès que la ligne floquée est là, la
     ligne d'origine est retirée (ou diminuée de la quantité floquée). Fenêtre fermée sans enregistrer : on oublie. */
  var CLE_NOUVELLE = 'pnPersoNouvelle';
  function idApo(it) { var p = it.properties || {}; return String(p._mws_cart || p.__mws_apo_cart || ''); }
  function personnaliserLigne(produit, variante) {
    if (!/^\d+$/.test(String(produit)) || !/^\d+$/.test(String(variante))) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var memes = (cart.items || []).filter(function (it) { return String(it.variant_id) === String(variante); });
        var ligne = memes.filter(function (it) { return !idApo(it); })[0];
        if (!ligne) return;
        try {
          sessionStorage.setItem(CLE_NOUVELLE, JSON.stringify({
            v: String(variante), cle: ligne.key, q: ligne.quantity, avant: memes.map(idApo).filter(Boolean), t: Date.now()
          }));
        } catch (e) {}
        var a = document.createElement('a');
        a.href = 'javascript:void(0);';
        a.className = 'mw-apo-configure-link pn-apo-cache';
        a.hidden = true;
        a.setAttribute('data-mw-apo-configure-link', String(produit));
        a.setAttribute('data-mw-apo-variant-id', String(variante));
        a.setAttribute('data-mw-apo-cart-id', '');
        document.body.appendChild(a);
        a.click();
        // fenêtre refermée : APO met plusieurs secondes à ajouter la ligne floquée puis recharge la page (parfois après
        // plus de 6 s, constaté le 21/10/2026). On relit donc le panier jusqu'à 25 s ; la ligne floquée arrive → la
        // ligne d'origine est retirée. Rien après 25 s (fenêtre annulée) : on oublie. Un rechargement entre-temps est
        // repris au chargement par nouvelleLigneApo.
        var vue = false, debut = Date.now();
        var veille = setInterval(function () {
          var ouverte = !!document.querySelector('.mw-tingle .tingle-modal--visible, .mw-tingle.tingle-modal--visible');
          if (ouverte) { vue = true; return; }
          if (!vue && Date.now() - debut < 20000) return;
          clearInterval(veille);
          var fin = Date.now() + 33000;
          // APO recharge en général la page dans les 2-3 s après « Enregistrer » : la page rechargée fait alors le
          // remplacement (nouvelleLigneApo au démarrage). On ne relit le panier ici qu'au-delà de 8 s, pour ne pas
          // retirer la ligne pendant ce rechargement.
          setTimeout(function relire() {
            nouvelleLigneApo().then(function (fait) {
              if (fait) return;
              if (Date.now() < fin) { setTimeout(relire, 1500); return; }
              try { sessionStorage.removeItem(CLE_NOUVELLE); } catch (e) {}
              a.remove();
            });
          }, 8000);
        }, 500);
      })
      .catch(function () {});
  }
  window.pnPersonnaliser = personnaliserLigne;
  // promesse : true si la ligne floquée est arrivée (ligne d'origine retirée, page rechargée) ou s'il n'y a rien à faire
  var remplacement = null;
  function nouvelleLigneApo() {
    var n;
    try { n = JSON.parse(sessionStorage.getItem(CLE_NOUVELLE) || 'null'); } catch (e) { n = null; }
    if (!n) return Promise.resolve(true);
    if (Date.now() - n.t > 15 * 60 * 1000) { try { sessionStorage.removeItem(CLE_NOUVELLE); } catch (e) {} return Promise.resolve(true); }
    if (remplacement) return remplacement;
    remplacement = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var floquee = items.filter(function (it) { return String(it.variant_id) === n.v && idApo(it) && n.avant.indexOf(idApo(it)) < 0; })[0];
        if (!floquee) return false;
        try { sessionStorage.removeItem(CLE_NOUVELLE); } catch (e) {}
        // la clé de la ligne change quand une remise s'y applique (3 achetés = 1 offert, constaté le 21/10/2026) :
        // à défaut, même variante sans identifiant APO
        var origine = items.filter(function (it) { return it.key === n.cle; })[0] ||
          items.filter(function (it) { return String(it.variant_id) === n.v && !idApo(it); })[0];
        if (!origine) return true;
        // APO peut recharger la page au même moment : la page reçue a alors encore l'ancienne ligne et notre reload
        // est écrasé (constaté le 21/10/2026). Repère posé AVANT la requête (la page peut se décharger avant la
        // réponse) : la page suivante se recharge une fois si ses lignes ne correspondent pas au panier (panierAJour).
        // keepalive : la requête aboutit même si la page se décharge entre-temps.
        try { sessionStorage.setItem('pnPanierARelire', String(Date.now())); } catch (e) {}
        return fetch('/cart/change.js', {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: origine.key, quantity: Math.max(0, origine.quantity - floquee.quantity) })
        }).then(function (r) {
          if (r.ok) {
            if (document.readyState === 'complete') location.reload();
            else window.addEventListener('load', function () { location.reload(); });
          }
          return true;
        });
      })
      .catch(function () { return false; })
      .then(function (fait) { remplacement = null; return fait; });
    return remplacement;
  }

  /* ── Bouton « Modifier » / « Personnaliser » sur chaque ligne de la page (demande du user, 21/10/2026) ──
     « Modifier » si la ligne est personnalisée, « Personnaliser » sinon ; seulement si le produit a des options APO
     (adresse publique d'APO : 200 = options, 204 = aucune ; même cache que le tiroir). La fenêtre d'APO s'ouvre ici :
     ligne avec identifiant APO → son lien « Éditer les options » (masqué, le bouton le remplace) ; ligne sans
     identifiant (ajoutée depuis les suggestions du tiroir) → personnaliserLigne, qui remplace la ligne après
     enregistrement. Les lignes de la page (#CartItem-n) suivent l'ordre de /cart.js. */
  var optionsApo = {};
  try { optionsApo = JSON.parse(sessionStorage.getItem('etOptionsApo') || '{}') || {}; } catch (e) {}
  function aDesOptions(produit, variante) {
    if (Object.prototype.hasOwnProperty.call(optionsApo, produit)) return Promise.resolve(optionsApo[produit]);
    var cfg = window.mwApoInit;
    if (!cfg || !cfg.shop_domain || cfg.cache_hash == null) return Promise.resolve(false);
    return fetch('https://apo-admin.mageworx.com/front/product/' + cfg.shop_domain + '/' + cfg.cache_hash + '/' + produit + '/' + variante + '.js', { credentials: 'omit' })
      .then(function (r) {
        optionsApo[produit] = r.status === 200;
        try { sessionStorage.setItem('etOptionsApo', JSON.stringify(optionsApo)); } catch (e) {}
        return optionsApo[produit];
      })
      .catch(function () { return false; });
  }
  function persoVisible(it) {
    var p = it.properties || {};
    return Object.keys(p).some(function (k) { return k.charAt(0) !== '_' && String(p[k]).trim() !== ''; });
  }
  var boutonsEnCours = false, boutonsARefaire = false;
  function boutonsLignes() {
    if (boutonsEnCours) { boutonsARefaire = true; return; }
    if (!document.querySelector('[id^="CartItem-"]')) return;
    boutonsEnCours = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return Promise.all((cart.items || []).map(function (it, i) {
          var ligne = document.getElementById('CartItem-' + (i + 1));
          if (!ligne || ligne.querySelector('.pn-modif')) return null;
          // page pas encore à jour (rechargement en cours) : la ligne n'est pas celle de /cart.js, on n'y touche pas
          var q = ligne.querySelector('[data-quantity-variant-id]');
          if (q && q.getAttribute('data-quantity-variant-id') !== String(it.variant_id)) return null;
          return aDesOptions(it.product_id, it.variant_id).then(function (ok) {
            var details = ligne.querySelector('.cart-item__details');
            if (!ok || !details || !ligne.isConnected || ligne.querySelector('.pn-modif')) return;
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'pn-modif';
            b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20h4L19 9a2.8 2.8 0 0 0-4-4L4 16v4Z"/><path d="m13.5 6.5 4 4"/></svg><span></span>';
            b.querySelector('span').textContent = persoVisible(it) ? T.modifier : T.personnaliser;
            b.addEventListener('click', function () {
              var id = idApo(it);
              var lien = id && ligne.querySelector('.mw-apo-configure-link:not([data-mw-apo-buy-again-link])');
              if (lien) lien.click(); // garde la remise des photos « Patch perso » (écouteur en capture plus haut)
              else if (id) ouvrirEdition(id);
              else personnaliserLigne(it.product_id, it.variant_id);
            });
            details.appendChild(b);
            ligne.classList.add('pn-a-modif');
          });
        }));
      })
      .catch(function () {})
      .then(function () {
        boutonsEnCours = false;
        if (boutonsARefaire) { boutonsARefaire = false; boutonsLignes(); }
      });
  }

  function editionDemandee() {
    var m = /[?&](modifier|personnaliser)=([^&#]*)/.exec(location.search);
    if (!m) return;
    var reste = location.search.replace(/([?&])(modifier|personnaliser)=[^&#]*&?/, '$1').replace(/[?&]$/, '');
    try { history.replaceState(history.state, '', location.pathname + reste + location.hash); } catch (e) {}
    var v = decodeURIComponent(m[2]);
    if (m[1] === 'modifier') ouvrirEdition(v);
    else personnaliserLigne(v.split('.')[0], v.split('.')[1]);
  }

  function panierAJour() {
    var t = 0;
    try { t = parseInt(sessionStorage.getItem('pnPanierARelire') || '0', 10); sessionStorage.removeItem('pnPanierARelire'); } catch (e) {}
    if (!t || Date.now() - t > 60000) return;
    // le retrait peut être encore en cours quand cette page arrive : quelques relectures sur ~7 s
    var essais = 0;
    (function relire() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (document.querySelectorAll('[id^="CartItem-"]').length !== (cart.items || []).length) { location.reload(); return; }
          if (++essais < 6) setTimeout(relire, 1200);
        })
        .catch(function () {});
    })();
  }

  function start() {
    panierAJour();
    nouvelleLigneApo();
    editionDemandee();
    traduire(document.body);
    lignesAFaire = false;
    lignesPanier();
    boutonsLignes();
    // page rechargée par APO après « Enregistrer » : la photo est peut-être à remettre
    if (persoEnAttente()) { restaurePerso(); surveillePerso(); }
    else photosDansCommande();
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
